export function removeEventsByClone(el) {
  var elClone = el.cloneNode(true), parent = el.parentNode;
  parent.insertBefore(elClone, el);
  el.remove();
  el = null;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/removeEventsByClone.js
// module id = 79
// module chunks = 0 1